// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oTYX1","importantInfo":"styles_importantInfo__nC9PH"};